module.exports = __webpack_public_path__ + "ce6bd5612f294f8d6632911098751d4f.png";